export default __webpack_public_path__ + "static/media/DocMultiplyFill.cef2df50.svg";